import React from 'react'
import { connect } from 'react-redux'
import { ISSUE_ERROR, ORDER_MODAL_ACTION_TEXT } from '../../../../helpers'
import { MODAL } from '../../../../reduxs'
import { IssueFileLimitModalStyle } from './styles'
import { ReactModal } from '../../../../components'

function IssueFileLimitModal(props) {
  const {
    language,
    isOpenIssueFileLimitModal,
    colorTheme,
    closeIssueFileLimitModal,
    openIssueReportModal,
  } = props

  const handleClickDone = () => {
    closeIssueFileLimitModal()
    openIssueReportModal()
  }

  return (
    <ReactModal isVisible={isOpenIssueFileLimitModal} width={440} borderRadius={8} >
      <IssueFileLimitModalStyle colorTheme={colorTheme} >
        <h2 className='issue-file-limit__title'>{ISSUE_ERROR.ERROR[language]}</h2>
        <p className='issue-file-limit__text'>
          {ISSUE_ERROR.TEXT[language]}
        </p>
        <button
          className='issue-file-limit__button--done'
          onClick={handleClickDone}
        >
          {ORDER_MODAL_ACTION_TEXT.DONE[language]}
        </button>
      </IssueFileLimitModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ orderReducer, accountReducer, modalReducer }) => {
  return {
    confirmItems: orderReducer.confirmItems,
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenIssueFileLimitModal: modalReducer.issueModal.isOpenIssueFileLimitModal,
    orderActionText: orderReducer.orderActionText,
    language: accountReducer.language,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeIssueFileLimitModal: () => dispatch(MODAL.action.setIssueFileLimitModal(false)),
    openIssueReportModal: () => dispatch(MODAL.action.setIssueReportModal(true)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(IssueFileLimitModal)